export default {
  SET_PAYOUTS: (state, list) => {
    state.list = list;
  },
  SET_TOTAL_PAYOUTS: (state, total) => {
    state.total = total;
  },
  SET_PAYOUTS_CUSTOMERS: (state, customers) => {
    state.customers = customers;
  },
  SET_PAYOUTS_INVOICES: (state, invoices) => {
    state.invoices = invoices;
  },
  SET_SELECTED: (state, payload) => {
    state.selected = payload;
  },
  SET_TABLE_OPTIONS: (state, payload) => {
    state.tableOptions = payload;
  },
  RESET_TABLE_OPTIONS: (state) => {
    state.tableOptions.page = 1;
  },
};
